import { IInspirationSmallHeaderBlock } from '@features/cms/typescript/index';
import styles from '@features/cms/components/inspirations/InspirationSmallHeaderBlock/InspirationSmallHeaderBlock.styles';
import Heading from '@components/Heading/Heading';
type PropsType = {
  data: IInspirationSmallHeaderBlock;
  isFirst?: boolean;
};
const InspirationSmallHeaderBlock = ({
  data,
  isFirst = false
}: PropsType) => <section id={data.code} sx={styles.styledSection}>
    <Heading h={isFirst ? 1 : 2} uppercase pb={24} mobile>
      {data.title}
    </Heading>
  </section>;
export default InspirationSmallHeaderBlock;